
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  FreeMode,
  EffectFade,
} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, FreeMode, EffectFade]);

document.addEventListener("DOMContentLoaded", function(event) {

  const swiper = new Swiper('.swiper', {
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        centeredSlides: true,
        watchSlidesProgress: true,
        breakpoints: {
          "1": {
            "slidesPerView": 1.2,
            "spaceBetween": 20
          },
          "650": {
            "slidesPerView": 1.8,
            "spaceBetween": 20

          },
          "800": {
            "slidesPerView": 2.5,
            "spaceBetween": 20

          },"900": {
            "slidesPerView": 3.2,
            "spaceBetween": 20

          },
          "1024": {
            "slidesPerView": 3.5,
            "spaceBetween": 20

          },
          "1280": {
            "slidesPerView": 4.8,
            "spaceBetween": 20

          },
          "1440": {
            "slidesPerView": 5.5,
            "spaceBetween": 20

          },
          "2000": {
            "slidesPerView": 6.5,
            "spaceBetween": 20

          }
        },
        on: {
          init: function() {
            checkArrow();
          },
          resize: function () {
            checkArrow();
          }
        }
  });

  function checkArrow() {
    var swiperPrev = Array.from(document.getElementsByClassName('swiper-button-prev') as HTMLCollectionOf<HTMLElement>)
    var swiperNext = Array.from(document.getElementsByClassName('swiper-button-next') as HTMLCollectionOf<HTMLElement>)
    if ( window.innerWidth > 1024  ) {
      swiperPrev[0].style.display = 'block';
      swiperNext[0].style.display = 'block';
    } else {
      swiperPrev[0].style.display = 'none';
      swiperNext[0].style.display = 'none';
    }
  }
  
  document.querySelector(".hamburger-menu").addEventListener("click", (e) => { 
      let treeNav = document.querySelector(".tree-nav");
      treeNav.classList.add("open")
  });
  
  document.querySelector(".close").addEventListener("click", (e) => { 
      let treeNav = document.querySelector(".tree-nav");
      treeNav.classList.remove("open")
  });
  
  let openArrow = document.querySelectorAll(".open-arrow");
  
  Array.from(openArrow).forEach((el) => { 
    el.addEventListener("click", (e) => { 
      const arrow = e.target as HTMLButtonElement;
      arrow.classList.toggle("active");
      arrow.parentElement.nextElementSibling.classList.toggle("open");
      let arrowsChildren = arrow.closest(".top-item") as HTMLElement;
      arrowsChildren.classList.toggle("active");
    });
  });
  
  let openPlus = document.querySelectorAll(".open-plus");
  
  Array.from(openPlus).forEach((el) => { 
    el.addEventListener("click", (e) => { 
      const plus = e.target as HTMLButtonElement;
      plus.classList.toggle("active");
      plus.parentElement.nextElementSibling.classList.toggle("open");
      let plusChildren = plus.closest(".top-item") as HTMLElement;
      plusChildren.classList.toggle("active");
    });
  });
  
  /* Blocks JS comes here below */
  const arrowButton = document.getElementById("hero-block__arrowButton");
  if (typeof(arrowButton) != 'undefined' && arrowButton != null){
    arrowButton.addEventListener("click", (e) => { 
      const bottomOfArrowParent = arrowButton.closest(".hero-block").getBoundingClientRect().height;
      window.scrollTo({
        top: Math.floor(bottomOfArrowParent),
        left: 0,
        behavior: 'smooth',
          });
        });
      }
      
      
      
      const questionElem = document.querySelectorAll(".faq-block__question");
      
      Array.from(questionElem).forEach((el) => { 
        el.addEventListener("click", (event) => { 
          const question = event.target as HTMLElement;
          question.closest(".faq-block__questWrap").classList.toggle("open");
        });
      });
      
    });
    
    //-----------Open and close theme-selector----------------//
    //Desktop------
    var themeSelectorElem = document.getElementById("theme-selector");
    window.addEventListener('click', function(e){   
      if (themeSelectorElem.contains(e.target as HTMLElement)){
        themeSelectorElem.querySelector(".options").classList.toggle("open");
        
      } else {
        themeSelectorElem.querySelector(".options").classList.remove("open");
      }
    });
    //Mobile------
    var mobileThemeSelectorElem = document.getElementById("mobile-theme-selector");
    window.addEventListener('click', function(e){   
      if (mobileThemeSelectorElem.contains(e.target as HTMLElement)){
        mobileThemeSelectorElem.classList.toggle("open");

        mobileThemeSelectorElem.querySelector(".options").classList.toggle("open");
      } else {
        mobileThemeSelectorElem.querySelector(".options").classList.remove("open");
      }
    });
    
    //------------------CookieHandler below:-----------------//
    
    function setCookie(cname: any, cvalue: any, exdays: any) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    async function destroyThemeCookie(name: string) {
      setCookie("themeSelector", "", "30"); 
    }

    const themeKiller = document.querySelectorAll(".kill-theme");

    Array.from(themeKiller).forEach((el) => { 
      el.addEventListener("click", async (event) => { 
          await destroyThemeCookie("themeSelector");
      });
    });

    const theme = document.querySelectorAll(".theme"); 
    Array.from(theme).forEach((el) => { 
      el.addEventListener("click", (event) => { 
        const selectedThemeElement = event.currentTarget as HTMLElement;
        const selectedTheme = selectedThemeElement.dataset.theme;
        const rootUrl = selectedThemeElement.dataset.starturl;
        setCookie("themeSelector", selectedTheme, "30");
        window.location.href = rootUrl;
      });
    });

    var langSelectorElem = document.getElementById("lang-selector");
    window.addEventListener('click', function(e){   
      if (langSelectorElem.contains(e.target as HTMLElement)){
        langSelectorElem.classList.toggle("open");
        
      } else {
        langSelectorElem.classList.remove("open");
      }
    });
   
    const swiper = new Swiper('.swiper-image-block', {
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      centeredSlides: true,
      watchSlidesProgress: true,
});

    const swiperHeroSection = new Swiper('.swiper-hero-section', {
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      centeredSlides: true,
      watchSlidesProgress: true,
});

var cookieDialog = document.querySelector(".accept-cookies") as HTMLElement;
if(cookieDialog != null){
    cookieDialog.addEventListener("click", (e) => { 
      setCookie("CONSENT", true, "365");
      document.querySelector(".cookie-information").classList.remove("show");
    });
}

//Fetching temperature from SMHI
    async function getTempValue() {
        const response = await fetch("https://opendata-download-metfcst.smhi.se/api/category/pmp3g/version/2/geotype/point/lon/13.615773/lat/57.436538/data.json");
        const answer = await response.json();

        try {
            var tempElement = document.querySelector('.temperature-facts');
            var tempArray = answer.timeSeries[0].parameters;
            for(let i = 0; i < tempArray.length; i++) {
              if(tempArray[i].name === "t")
              {
                tempElement.innerHTML = `${Math.round(tempArray[i].values[0])}°C`;
              }
            }

            /* tempElement.innerHTML = `${Math.round(answer.timeSeries[0].parameters[10].values[0])}°C`; */

        } catch (e) {
            if(tempElement != null){
              tempElement.innerHTML = `0°C`;
            }
        }
    } 
    getTempValue();
    setInterval(getTempValue, 3000 * 60 * 60);